<div class="checkbox-container">
  <div class="content">
    <div class="checkbox-group">
      <div class="option">
        <ul class="list-group" style="height: 200px; overflow: auto">
          <li name="contactLi" class="list-group" *ngFor="let contact of contacts; let i = index" class="border-bottom ps-4 py-2">
            <label class="form-check-label">
              <!-- Muestra checkbox solo si checkboxes es true -->
              <input name="selectedContact" *ngIf="checkboxes" type="checkbox" [disabled]="checkboxesDisabled" [(ngModel)]="contact.selected"
                (change)="onCheckboxChange()" class="form-check-input me-4">
              <span class="me-4">{{contact.commerceNumber}}</span>{{contact.commerceName}}
            </label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>